module.exports = __webpack_public_path__ + "img/img-datos-personales.0320449d.png";